import {IFormPanelView} from "./types/IFormPanelView";

export class FormPanelView implements IFormPanelView {
  $type_IFormPanelView: 1 = 1;

  parent?: any;
}
